import React, { Component } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import Modal from "react-responsive-modal";
import { Button, Form, FormGroup, Label, Col } from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import NumberFormat from "react-number-format";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import ReactSelect from "react-select";

import { numberSeparator } from "../function/Format";
import { Post, Get, Delete, JENIS_DESA } from "../function/Koneksi";

const initialFormData = {
  uuid: "",
  tahun: new Date().getFullYear(),
  jenis: "",
  label: "",
  realisasi: ""
};

// Daftar sub-kategori per jenis anggaran
const SUB_KATEGORI_OPTIONS = {
  Pendapatan: [
    { value: "Pendapatan Asli Desa", label: "Pendapatan Asli Desa" },
    { value: "Pendapatan Transfer", label: "Pendapatan Transfer" },
    { value: "Pendapatan Lain-lain", label: "Pendapatan Lain-lain" }
  ],
  Belanja: [
    {
      value: "Penyelenggaraan Pemerintahan Desa",
      label: "Penyelenggaraan Pemerintahan Desa"
    },
    {
      value: "Pelaksanaan Pembangunan Desa",
      label: "Pelaksanaan Pembangunan Desa"
    },
    {
      value: "Pembinaan Kemasyarakatan Desa",
      label: "Pembinaan Kemasyarakatan Desa"
    },
    {
      value: "Pemberdayaan Masyarakat Desa",
      label: "Pemberdayaan Masyarakat Desa"
    },
    {
      value: "Penanggulangan Bencana, Keadaan Darurat, dan Mendesak Desa",
      label: "Penanggulangan Bencana, Keadaan Darurat, dan Mendesak Desa"
    }
  ],
  Pembiayaan: [
    { value: "Penerimaan Pembiayaan", label: "Penerimaan Pembiayaan" },
    { value: "Pengeluaran Pembiayaan", label: "Pengeluaran Pembiayaan" }
  ]
};

class InformasiAnggaran extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      pagination: {},
      status: {
        form: false,
        btnForm: false
      },
      formData: initialFormData,
      judul: "Tambah Data APB Desa",
      alert: null,
      loading: false,
      filter: {
        q: ""
      },

      jenis: null,
      kategoriOptions: [],
      kategori: null
    };
  }

  hideAlert = () => {
    this.setState({ alert: null });
  };

  // ================== Ambil data dari API ==================
  fetch = (params = {}) => {
    this.setState({ loading: true });
    const link = `?page=${params.page || 1}${
      this.state.filter.q ? `&q=${this.state.filter.q}` : ""
    }`;

    Get("info-anggaran" + link, null, res => {
      this.setState({
        data: res && res.results && res.results.data ? res.results.data : [],
        pagination: res && res.results ? res.results : {},
        loading: false
      });
    });
  };

  // ================== Pagination ==================
  renderPagination = () => {
    const data = this.state.pagination;
    if (
      !data ||
      !data.total ||
      data.total <= 0 ||
      !data.last_page ||
      data.last_page <= 1
    ) {
      return null;
    }

    const { current_page, last_page } = data;
    const btnClass =
      "btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2";
    const btnActiveClass =
      "btn btn-danger btn-square btn-sm pr-3 pl-3 pt-2 pb-2";

    let start = Math.max(1, current_page - 2);
    let end = Math.min(last_page, start + 4);
    if (end - start < 4) {
      start = Math.max(1, end - 4);
    }

    const pages = [];
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return (
      <div className="pull-right text-white">
        <button className={btnClass} onClick={() => this.fetch({ page: 1 })}>
          {"<<"}
        </button>
        {current_page > 1 && (
          <button
            className={btnClass}
            onClick={() => this.fetch({ page: current_page - 1 })}
          >
            {"<"}
          </button>
        )}
        {pages.map(i => (
          <button
            key={i}
            className={i === current_page ? btnActiveClass : btnClass}
            onClick={() => this.fetch({ page: i })}
          >
            {i}
          </button>
        ))}
        {current_page < last_page && (
          <button
            className={btnClass}
            onClick={() => this.fetch({ page: current_page + 1 })}
          >
            {">"}
          </button>
        )}
        <button
          className={btnClass}
          onClick={() => this.fetch({ page: last_page })}
        >
          {">>"}
        </button>
      </div>
    );
  };

  // ================== Cari Data ==================
  cariData = e => {
    if (e.key === "Enter") {
      this.setState({ filter: { q: e.target.value } }, () => {
        this.fetch();
      });
    }
  };

  // ================== Simpan Data ==================
  simpan = e => {
    e.preventDefault();

    this.setState({ status: { ...this.state.status, btnForm: true } });

    if (this.state.jenis && this.state.kategori) {
      let bodyData = {
        jenis: this.state.jenis.value,
        tahun: this.state.formData.tahun,
        label: this.state.kategori.value,
        realisasi: String(this.state.formData.realisasi).replace(/[^\d]/g, ""),
        uuid: this.state.formData.uuid
      };

      let action = "";
      let expectedStatus = 204;
      let method = "create";
      if (bodyData.uuid === "") {
        action = "tambah";
        expectedStatus = 201;
        bodyData.uuid = null;
      } else {
        action = "ubah";
        expectedStatus = 200;
        method = "update";
      }

      Post("info-anggaran/" + method, bodyData.uuid, bodyData, res => {
        if (res.status === expectedStatus) {
          this.setState({
            alert: {
              type: "success",
              title: "Data APB Desa " + JENIS_DESA,
              message: "Berhasil " + action + " Data"
            },
            formData: initialFormData,
            jenis: null,
            kategori: null,
            kategoriOptions: [],
            status: {
              form: false,
              btnForm: false
            }
          });
        } else {
          this.setState({
            alert: {
              type: "danger",
              title: "Data APB Desa " + JENIS_DESA,
              message: "Gagal " + action + " Data"
            },
            status: {
              ...this.state.status,
              btnForm: false
            }
          });
        }

        this.fetch();
      });
    } else {
      this.setState({
        alert: {
          type: "danger",
          title: "Data APB Desa " + JENIS_DESA,
          message: "Jenis Anggaran dan Kategori harus dipilih!"
        },
        status: {
          ...this.state.status,
          btnForm: false
        }
      });
    }
  };

  // ================== Ubah Data ==================
  ubahData = row => {
    this.setState({
      judul: "Ubah Data APB Desa " + JENIS_DESA
    });

    if (row) {
      let jenisValue = row.jenis;
      let kategoriOptions = SUB_KATEGORI_OPTIONS[jenisValue] || [];
      let kategoriMatch = kategoriOptions.find(opt => opt.value === row.label);

      this.setState({
        formData: {
          uuid: row.uuid,
          tahun: row.tahun,
          jenis: row.jenis,
          label: row.label,
          realisasi: row.realisasi
        },
        jenis: {
          value: jenisValue,
          label: jenisValue
        },
        kategori: kategoriMatch || { value: row.label, label: row.label },
        kategoriOptions: kategoriOptions,
        status: {
          ...this.state.status,
          form: true
        }
      });
    }
  };

  // ================== Hapus Data ==================
  konfirmHapus = id => {
    this.setState({
      alert: {
        type: "danger",
        title: "Yakin ingin hapus data ?",
        message: "Proses ini tidak dapat dibatalkan!",
        showCancel: true,
        confirmBtnText: "Hapus",
        onConfirm: () => this.hapusData(id)
      }
    });
  };

  hapusData = id => {
    this.hideAlert();
    Delete("info-anggaran/delete", id, res => {
      if (res === 200) {
        this.setState({
          alert: {
            type: "success",
            title: "Data APB Desa " + JENIS_DESA,
            message: "Berhasil Hapus Data"
          }
        });
      } else {
        this.setState({
          alert: {
            type: "danger",
            title: "Data APB Desa " + JENIS_DESA,
            message: "Gagal Hapus Data"
          }
        });
      }
      this.fetch();
    });
  };

  // ================== Buka / Tutup Form ==================
  bukaForm = () => {
    this.setState({
      status: { ...this.state.status, form: true }
    });
  };

  tutupForm = () => {
    this.setState({
      status: { ...this.state.status, form: false }
    });
  };

  // ================== Tombol Aksi di Tabel ==================
  tombolAksi = (cell, row) => {
    return (
      <div>
        <Button
          size="xs"
          color="success"
          className="btn-icon mr-1"
          onClick={() => this.ubahData(row)}
        >
          <i className="fa fa-pencil"></i>
        </Button>
        <Button
          size="xs"
          color="danger"
          className="btn-icon mr-1"
          onClick={() => this.konfirmHapus(row.uuid)}
        >
          <i className="fa fa-trash"></i>
        </Button>
      </div>
    );
  };

  componentDidMount() {
    this.fetch();
  }

  render() {
    const data = this.state.data;

    const columns = [
      {
        dataField: "no",
        text: "No",
        isDummyField: true,
        csvExport: false,
        headerAlign: "center",
        align: "center",
        formatter: (key, obj, index) => {
          let current_pagenum = this.state.pagination.current_page || 1;
          let total_records_per_page = this.state.pagination.per_page || 20;
          let row_index = index + 1;
          let serial_num =
            total_records_per_page * (current_pagenum - 1) + row_index;
          return serial_num;
        }
      },
      {
        dataField: "tahun",
        headerAlign: "center",
        align: "center",
        text: "Tahun",
        sort: false
      },
      {
        dataField: "jenis",
        headerAlign: "center",
        align: "center",
        text: "Jenis",
        sort: false
      },
      {
        dataField: "label",
        headerAlign: "center",
        align: "center",
        text: "Kategori",
        sort: false
      },
      {
        dataField: "realisasi",
        headerAlign: "center",
        align: "center",
        text: "Anggaran",
        sort: false,
        formatter: function(cell, row) {
          return "Rp. " + numberSeparator(row.realisasi);
        }
      },
      {
        dataField: "aksi",
        headerAlign: "center",
        align: "center",
        text: "Aksi",
        style: { width: "130px" },
        formatter: this.tombolAksi
      }
    ];

    return (
      <div>
        {this.state.alert && (
          <SweetAlert
            type={this.state.alert.type}
            title={this.state.alert.title}
            showCancel={this.state.alert.showCancel || false}
            confirmBtnText={this.state.alert.confirmBtnText || "OK"}
            confirmBtnBsStyle={
              this.state.alert.showCancel ? "danger" : "success"
            }
            cancelBtnBsStyle="success"
            onConfirm={this.state.alert.onConfirm || this.hideAlert}
            onCancel={this.hideAlert}
          >
            {this.state.alert.message}
          </SweetAlert>
        )}

        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card mb-0">
                <div className="card-header">
                  <div className="row">
                    <div className="col-sm-6">
                      <input
                        type="text"
                        className="form-control"
                        id="cariTable"
                        placeholder="Cari Data berdasarkan Tahun atau Jenis Anggaran"
                        onKeyDown={this.cariData}
                      />
                    </div>
                    <div className="col-sm-6 text-right">
                      <Button
                        size="sm"
                        color="success"
                        className="btn-square"
                        onClick={() => {
                          this.setState({
                            judul: "Tambah Data APB Desa " + JENIS_DESA,
                            formData: initialFormData,
                            jenis: null,
                            kategori: null,
                            kategoriOptions: []
                          });
                          this.bukaForm();
                        }}
                      >
                        Tambah Data
                      </Button>
                    </div>
                  </div>
                </div>
                <div className="card-body datatable-react">
                  {this.state.loading ? (
                    <div className="row">
                      <div className="col-sm-12" align="center">
                        <img
                          alt="loading"
                          src={require("../assets/images/tes-loading.gif")}
                          style={{ borderRadius: "10px", width: "100px" }}
                        />
                      </div>
                    </div>
                  ) : data.length !== 0 ? (
                    <>
                      <BootstrapTable
                        keyField="uuid"
                        data={data}
                        columns={columns}
                      />
                      {this.renderPagination()}
                    </>
                  ) : (
                    <h6 className="text-center mb-2 mt-2">Belum ada data</h6>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        <Modal
          open={this.state.status.form}
          onClose={this.tutupForm}
          closeOnEsc={false}
          closeOnOverlayClick={false}
          styles={{ modal: { width: "65%", maxWidth: "unset" } }}
        >
          <Form className="theme-form" onSubmit={this.simpan}>
            <div className="modal-header">
              <h5 className="modal-title">{this.state.judul}</h5>
            </div>
            <div className="modal-body">
              <input
                className="form-control"
                id="uuid"
                type="hidden"
                value={this.state.formData.uuid}
              />
              <FormGroup className="row">
                <Label className="col-sm-3 col-form-label">
                  Jenis Anggaran
                </Label>
                <Col sm="9">
                  <ReactSelect
                    inputId="jenis"
                    classNamePrefix="select"
                    onChange={e => {
                      this.setState({
                        jenis: e,
                        kategori: null,
                        kategoriOptions: e
                          ? SUB_KATEGORI_OPTIONS[e.value] || []
                          : []
                      });
                    }}
                    value={this.state.jenis}
                    name="jenis"
                    options={[
                      { value: "Pendapatan", label: "Pendapatan" },
                      { value: "Belanja", label: "Belanja" },
                      { value: "Pembiayaan", label: "Pembiayaan" }
                    ]}
                    placeholder="Pilih Jenis Anggaran"
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Label className="col-sm-3 col-form-label">Kategori</Label>
                <Col sm="9">
                  <ReactSelect
                    inputId="kategori"
                    classNamePrefix="select"
                    onChange={e => {
                      this.setState({ kategori: e });
                    }}
                    value={this.state.kategori}
                    name="kategori"
                    options={this.state.kategoriOptions}
                    placeholder={
                      this.state.jenis
                        ? "Pilih Kategori"
                        : "Pilih Jenis Anggaran terlebih dahulu"
                    }
                    isDisabled={!this.state.jenis}
                    noOptionsMessage={() =>
                      "Pilih Jenis Anggaran terlebih dahulu"
                    }
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Label className="col-sm-3 col-form-label">Tahun</Label>
                <Col sm="9">
                  <input
                    className="form-control"
                    id="tahun"
                    type="number"
                    placeholder="Tahun"
                    value={this.state.formData.tahun}
                    onChange={e => {
                      this.setState({
                        formData: {
                          ...this.state.formData,
                          tahun: e.target.value
                        }
                      });
                    }}
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Label className="col-sm-3 col-form-label">
                  Anggaran (Rp.)
                </Label>
                <Col sm="9">
                  <NumberFormat
                    className="form-control"
                    id="anggaran"
                    name="anggaran"
                    thousandSeparator={true}
                    prefix={"Rp. "}
                    placeholder="Masukkan nominal anggaran. Contoh : 1.500.000"
                    value={this.state.formData.realisasi}
                    onChange={e => {
                      this.setState({
                        formData: {
                          ...this.state.formData,
                          realisasi: e.target.value
                        }
                      });
                    }}
                    required
                  />
                </Col>
              </FormGroup>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-warning"
                disabled={this.state.status.btnForm}
                onClick={this.tutupForm}
              >
                Tutup
              </button>
              <button
                type="submit"
                className="btn btn-success"
                disabled={this.state.status.btnForm}
              >
                {this.state.status.btnForm ? "Loading..." : "Simpan"}
              </button>
            </div>
          </Form>
        </Modal>
      </div>
    );
  }
}

export default InformasiAnggaran;
